<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarydealerfilestable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarydealerfilestable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Secondarydealerfilestable from "./components/secondarydealerfilestable.vue";
	import {
		InventoryClassList,
	} from '@/api/home'

	import {
		GetOrgConsignmentList,
		OrgConsignmentVoucherType,
		OrgConsignmentStatus,
		ExportOrgConsignment
	} from "@/api/newsapi";
	import utils from "../../../common/utils";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarydealerfilestable,
		},
		data() {
			return {
				showorhide: true,
				CusName: "",
				InvClass: "",
				Year: "",
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				form: {},
				formdata: [{
						inputdata: "",
						title: "产品线",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "315px",
						btx: true,
						options: [],
						lablewith: '117px',
						event: "invClass"
					}, {
						inputdata: "",
						title: "单据类型",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "315px",
						btx: true,
						options: [],
						lablewith: '117px',
					}, {
						inputdata: "",
						title: "状态",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "315px",
						btx: true,
						options: [],
						lablewith: '120px',
					},
					{
						inputdata: "",
						title: "付款方",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "305px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "LEVEL3",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "305px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "产品型号/名称",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "305px",
						lablewith: "120px",
					},
					{
						inputdata: "",
						title: "销售员",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "305px",
						lablewith: "117px",
					}, {
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "date",
						width: "200px",
						lablewith: "115px",
					}
				],
			};
		},
		mounted() {
			//this.customerList();
			this.$refs.seselect[7].startTime = this.$utils.getFYearDate();
			this.$message.warning("请填写搜索条件！");
			this.inventoryClassList();
			this.getVoucherType();
			this.getStatus();
		},
		methods: {
			// 列表
			async customerList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await GetOrgConsignmentList({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				loading.close();
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[0].options.push(obj);
					})
				}
			},
			//类型
			async getVoucherType() {
				let {
					code,
					data
				} = await OrgConsignmentVoucherType({});
				if (code == 0) {
					this.formdata[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text,
						};
						this.formdata[1].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			//类型
			async getStatus() {
				let {
					code,
					data
				} = await OrgConsignmentStatus({});
				if (code == 0) {
					this.formdata[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text,
						};
						this.formdata[2].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			// 导出
			async sMSReportIMSSalesExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportOrgConsignment({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `新模式报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.sMSReportIMSSalesExport()
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
					item.startTime = "";
					item.endTime = "";
				});
			},
			select() {
				this.pageindex = 1;
				this.form.InvClass = this.$refs.seselect[0].modelvalue;
				this.form.VoucherType = this.$refs.seselect[1].modelvalue;
				this.form.Status = this.$refs.seselect[2].modelvalue;
				this.form.Customer = this.$refs.seselect[3].modelvalue;
				this.form.LEVEL3 = this.$refs.seselect[4].modelvalue;
				this.form.Inventory = this.$refs.seselect[5].modelvalue;
				this.form.SalesMan = this.$refs.seselect[6].modelvalue;
				this.form.Date1 = this.$refs.seselect[7].startTime;
				this.form.Date2 = this.$refs.seselect[7].endTime;
				this.customerList();
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.customerList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.customerList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 170px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>